import { render, staticRenderFns } from "./VSpinLoader.vue?vue&type=template&id=337b1b65&scoped=true"
import script from "./VSpinLoader.vue?vue&type=script&lang=js"
export * from "./VSpinLoader.vue?vue&type=script&lang=js"
import style0 from "./VSpinLoader.vue?vue&type=style&index=0&id=337b1b65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b1b65",
  null
  
)

export default component.exports